import React from "react";
import Chart from "react-apexcharts";

export function HACCPChart5({ haccp }) {
  const isValidHaccp = Array.isArray(haccp) && haccp.length > 0;
  if (!isValidHaccp) return null;

  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Des'];
  const bulanList = ['jan', 'feb', 'mar', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'des'];

  const categories = monthNames.slice(0, 6);

  const getDataPerGrade = (grade) => {
    const item = haccp.find(row => row.grade === grade);
    if (!item) return bulanList.slice(0, 6).map(() => 0);
    return bulanList.slice(0, 6).map(bln => item[bln] ?? 0);
  };

  const chartOptions = {
    chart: {
      stacked: false,
      toolbar: { show: false },
    },
    colors: ['#008FFB', '#FF4560', '#00E396', '#FEB019'],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "45%",
        endingShape: "rounded",
        borderRadius: 5,
      },
    },
    legend: {
      show: true,
      position: 'top',
    },
    dataLabels: { enabled: false },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories,
      labels: {
        minHeight: 20,
        maxHeight: 20,
        style: { colors: "#8A92A6" },
      },
    },
    yaxis: {
      title: { text: "" },
      labels: {
        minWidth: 19,
        maxWidth: 19,
        style: { colors: "#8A92A6" },
      },
    },
    fill: {
      opacity: 1,
      type: "solid",
      colors: ['#008FFB', '#FF4560', '#00E396', '#FEB019'],
    },
    tooltip: {
      y: {
        formatter: val => val.toLocaleString("id-ID"),
      },
    },
  };

  const chartSeries = [
    { name: "Grade A", data: getDataPerGrade("A") },
    { name: "Grade B", data: getDataPerGrade("B") },
    { name: "Grade C", data: getDataPerGrade("C") },
  ];

  return (
    <Chart
      options={chartOptions}
      series={chartSeries}
      type="bar"
      height={300}
    />
  );
}